import { GoodsList as GoodsListComponent } from 'components/goods/GoodsList/GoodsList'

export const GoodsList: React.FC = () => {
  return <GoodsListComponent />
}